var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4779 13.5007C23.3647 15.4271 21.7643 17.0267 19.8373 18.1388C17.9103 19.2509 15.7246 19.8363 13.4997 19.8363C11.2748 19.8363 9.08909 19.2509 7.16208 18.1388C5.23508 17.0267 3.63463 15.4271 2.52148 13.5007C3.63242 11.5716 5.23209 9.96922 7.15938 8.85507C9.08667 7.74091 11.2735 7.1543 13.4997 7.1543C15.7258 7.1543 17.9127 7.74091 19.84 8.85507C21.7673 9.96922 23.367 11.5716 24.4779 13.5007Z",
    stroke: "#2555EF",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 17.0803C15.4774 17.0803 17.0803 15.4774 17.0803 13.5001C17.0803 11.5228 15.4774 9.91992 13.5001 9.91992C11.5228 9.91992 9.91992 11.5228 9.91992 13.5001C9.91992 15.4774 11.5228 17.0803 13.5001 17.0803Z",
    stroke: "#2555EF",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyeIcon.19326f7c.svg";
export { ForwardRef as ReactComponent };